import { render, staticRenderFns } from "./FullTextReviewEventLogItem.vue?vue&type=template&id=0807b795&scoped=true&"
import script from "./FullTextReviewEventLogItem.vue?vue&type=script&lang=js&"
export * from "./FullTextReviewEventLogItem.vue?vue&type=script&lang=js&"
import style0 from "./FullTextReviewEventLogItem.vue?vue&type=style&index=0&id=0807b795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0807b795",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
